// extracted by mini-css-extract-plugin
module.exports = {"contact":"index-module--contact--30J9u"};